import { render, staticRenderFns } from "./AnimatedPlaceholder.vue?vue&type=template&id=74372c46&scoped=true"
import script from "./AnimatedPlaceholder.vue?vue&type=script&lang=js"
export * from "./AnimatedPlaceholder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74372c46",
  null
  
)

export default component.exports